import { Tab, Tabs, withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import RefreshBar from '../Common/RefreshBar';
import TerminalMenu from "../../header/common/TerminalMenu";

const styles = (theme) => ({
  container: {
    display: 'flex',
    padding: '12 0',
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  option: {
    padding: '0 4px'
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px'
  },
  selectedOption: {
    color: theme.palette.primary.main,
    borderBottom: `2px solid ${theme.palette.primary.main}`
  },
  tabsIndicator: {
    backgroundColor: theme.HeaderSelectedText
  },
  tabRoot: {
    fontWeight: '600',
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    textTransform: 'none',
    opacity: 1,
    minWidth: 60,
    minHeight: 0,
    '&:hover': {
      color: theme.HeaderSelectedText
    },
    '&$tabSelected': {
      color: theme.HeaderSelectedText
    },
    '&:focus': {
      color: theme.HeaderSelectedText
    }
  },
  tabsRoot: {
    minHeight: 0
  },
  tabSelected: {
    color: theme.HeaderSelectedText
  },
  labelContainer: {
    padding: '2 12px'
  },
  terminalContainer: {
    display: 'flex',
    marginLeft: 'auto',
    paddingLeft: 10,
    '&>div': {
      padding: 0
    }
  },
  displayDiv: {
    display: 'flex',
    alignItems: 'center'
  }
});

const Filters = ({
  filterOptions,
  onChange,
  classes,
  userData,
  currentTerminalId,
  onTerminalChange,
  handleRefreshClick,
  headerId
}) => {
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0]);

  const updateFilter = (_event, value) => {
    if (value !== selectedFilter.value) {
      const filter = filterOptions.find((option) => option.value === value);
      setSelectedFilter(filter);
      onChange(filter);
    }
  };

  const onTerminalSelected = (terminal) => {
    onTerminalChange(terminal);
  };

  return (
    <div className={classes.container}>
      <div className={classes.optionsContainer}>
        <Tabs
          value={selectedFilter.value}
          onChange={updateFilter}
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabsIndicator
          }}>
          {filterOptions?.map((option) => (
            <Tab
              key={option.value}
              disableRipple
              label={option.label}
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
                labelContainer: classes.labelContainer
              }}
              value={option.id}
            />
          ))}
        </Tabs>
      </div>
      <div className={classes.displayDiv}>
        <RefreshBar handleRefreshClick={handleRefreshClick} headerId={headerId} />
        {userData ? (
          <div id="terminalContainer" className={classes.terminalContainer}>
            <TerminalMenu
              userData={userData}
              currentTerminalId={currentTerminalId}
              onChange={onTerminalSelected}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default withStyles(styles)(Filters);
